import { useResources } from "../../hooks/useResources";
import "./FilterTabs.scss";

export type FilterType = "all" | "published" | "unpublished" | "pending_graphics";

interface FilterTabsProps {
  activeFilter: FilterType;
  counts: {
    all: number;
    published: number;
    unpublished: number;
    pending_graphics: number;
  };
  onFilterChange: (filter: FilterType) => void;
}

const FilterTabs = ({
  activeFilter,
  counts,
  onFilterChange,
}: FilterTabsProps) => {
  const { getResourceValue } = useResources();

  const filters = [
    { key: "all" as FilterType, label: getResourceValue("all","ALL"), count: counts.all },
    {
      key: "published" as FilterType,
      label: getResourceValue("published", "Published"),
      count: counts.published,
    },
    {
      key: "unpublished" as FilterType,
      label: getResourceValue("unpublished", "Unpublished"),
      count: counts.unpublished,
    },
    {
      key: "pending_graphics" as FilterType,
      label: getResourceValue("pending_graphics", "Pending Graphics"),
      count: counts.pending_graphics,
    },
  ];

  return (
    <div className="filter-tabs">
      {filters.map((filter, index) => (
        <div key={filter.key} className="filter-tabs__item">
          {index > 0 && <div className="filter-tabs__divider"></div>}
          <button
            className={`filter-tabs__button ${
              activeFilter === filter.key ? "filter-tabs__button--active" : ""
            }`}
            onClick={() => onFilterChange(filter.key)}
          >
            <span className="filter-tabs__label">{filter.label}</span>
            <span
              className={`filter-tabs__count ${
                activeFilter === filter.key ? "filter-tabs__count--active" : ""
              }`}
            >
              ({filter.count})
            </span>
          </button>
        </div>
      ))}
    </div>
  );
};

export default FilterTabs;
